export const API_BASE: string = (import.meta as any).env?.VITE_API_BASE || '';

const TOKEN_KEY = 'unburden_session_token';

export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

// For <img>/<a> URLs that can't carry an Authorization header.
export function authedUrl(path: string): string {
  const token = getToken();
  if (!token) return apiUrl(path);
  const sep = path.includes('?') ? '&' : '?';
  return apiUrl(`${path}${sep}token=${encodeURIComponent(token)}`);
}

// fetch with the session token attached; a 401 drops the token and kicks the
// app back to the login screen via the auth:required event.
export async function authFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const token = getToken();
  const headers = new Headers(init.headers);
  if (token) headers.set('Authorization', `Bearer ${token}`);
  const response = await fetch(apiUrl(path), { ...init, headers });
  if (response.status === 401) {
    clearToken();
    window.dispatchEvent(new Event('auth:required'));
  }
  return response;
}
